import IconeMagistrado from '@/img/IconeMagistrado';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import ModalComposicao from '../sessao/ModalComposicao';
import PropTypes from 'prop-types';

class AbrirDialogComposicaoButton extends ReactComponent {
    dialogAberta = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogAberta: observable,
            abrirDialog: action,
            fecharDialog: action
        });
    }

    abrirDialog = () => {
        this.dialogAberta = true;
    };

    fecharDialog = () => {
        this.dialogAberta = false;
        this.props.onClose?.();
    };

    cancelarAcao = () => {
        this.dialogAberta = false;
        this.props.onCancel?.();
    };

    renderBotao() {
        const {
            variant = 'icone',
            iconColor = variant === 'icone' ? 'black' : 'primary',
            iconPosition = 'start',
            texto = 'Editar composição',
            disabled = false,
            tooltipPlacement = 'top',
            tooltipTitle = 'Editar composição'
        } = this.props;

        const icone = <IconeMagistrado sx={{ color: iconColor }} />;

        if (variant === 'icone') {
            return (
                <Tooltip
                    title={<Typography>{tooltipTitle}</Typography>}
                    placement={tooltipPlacement}
                >
                    <div>
                        <IconButton
                            onClick={this.abrirDialog}
                            style={{ cursor: 'pointer', padding: '2px 5px' }}
                            size="large"
                            disabled={disabled}
                        >
                            {icone}
                        </IconButton>
                    </div>
                </Tooltip>
            );
        }

        return (
            <Button
                onClick={this.abrirDialog}
                variant={variant}
                color="primary"
                disabled={disabled}
                startIcon={iconPosition === 'start' ? icone : null}
                endIcon={iconPosition === 'end' ? icone : null}
            >
                {texto}
            </Button>
        );
    }

    render() {
        const { registro, ...restProps } = this.props;

        return (
            <>
                {this.renderBotao()}

                {this.dialogAberta && (
                    <ModalComposicao
                        open={this.dialogAberta}
                        registro={registro}
                        onClose={this.fecharDialog}
                        onCancel={this.cancelarAcao}
                        {...restProps}
                    />
                )}
            </>
        );
    }
}

AbrirDialogComposicaoButton.propTypes = {
    /** Variante do botão. 'icone' renderiza IconButton, as demais renderizam o Button do MUI */
    variant: PropTypes.oneOf(['icone', 'text', 'outlined', 'contained']),

    /** Texto exibido dentro do botão (quando não for variante 'icone') */
    texto: PropTypes.string,

    /** Define se o botão está desabilitado */
    disabled: PropTypes.bool,

    /** Título exibido no Tooltip */
    tooltipTitle: PropTypes.node,

    /** Posição do Tooltip (ex: 'top', 'bottom', 'left', 'right') */
    tooltipPlacement: PropTypes.string,

    /** Cor do ícone. Aceita cores do tema (primary.main) ou strings CSS (white, #000) */
    iconColor: PropTypes.string,

    /** Posição do ícone em relação ao texto no componente Button */
    iconPosition: PropTypes.oneOf(['start', 'end']),

    /** Registro que será passado para o ModalComposicao */
    registro: PropTypes.object.isRequired,

    /** Callback disparado ao fechar o modal */
    onClose: PropTypes.func,

    /** Callback disparado ao cancelar a ação no modal */
    onCancel: PropTypes.func
};

export default inject('stores')(observer(AbrirDialogComposicaoButton));
